const palettes = ["#049593", "blue"];

export default palettes;
